import React, { isValidElement } from "react";

import { SvgIconTypeMap } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { OverridableComponent } from "@mui/material/OverridableComponent";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";
import Typography, { TextColor } from "@src/sharedComponents/Typography/Text";

import styles from "./MenuOption.module.css";

type MenuOptionIconComponent =
  | (OverridableComponent<SvgIconTypeMap<unknown, "svg">> & { muiName: string })
  | React.ReactNode;

export type MenuOption = {
  label: string;
  onClick: React.MouseEventHandler<HTMLLIElement>;
  className?: string;
  menuItemClassName?: string;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  isCloseOnClick?: boolean;
  IconComponent?: MenuOptionIconComponent;
  textColor?: TextColor;
};

interface MenuOptionProps extends MenuOption {
  handleCloseMenu: React.MouseEventHandler<HTMLElement>;
}

const MenuOption: React.FC<MenuOptionProps> = ({
  label,
  onClick,
  className,
  menuItemClassName,
  isDisabled,
  isReadOnly,
  isCloseOnClick,
  IconComponent,
  handleCloseMenu,
  textColor = "text",
}) => {
  return (
    <MenuItem
      className={toClassName(styles.menuItem, menuItemClassName, {
        [styles.menuItemReadOnly]: isReadOnly,
      })}
      disabled={isReadOnly ?? isDisabled}
      onClick={(event) => {
        onClick(event);
        if (isCloseOnClick) {
          handleCloseMenu(event);
        }
      }}
    >
      {IconComponent ? (
        isValidElement(IconComponent) ? (
          IconComponent
        ) : (
          // @ts-expect-error ts inferring goes crazy here
          <IconComponent className={styles.menuItemIcon} />
        )
      ) : null}
      <Typography color={textColor} variant="title3" className={className}>
        {label}
      </Typography>
    </MenuItem>
  );
};

export default MenuOption;
